import React from "react";
import { SvgIcon } from "@material-ui/core";

/**
 * Ícono phone (Figma barra-de-contacto · Atención al cliente).
 * Stroke 2, viewBox 32×32.
 */
const PhoneAtencion = props => (
  <SvgIcon viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M19.3229 22.173C19.0289 22.2465 18.7187 22.2176 18.4433 22.0911C14.7395 20.2733 11.7423 17.2799 9.91993 13.5784C9.78496 13.3015 9.75 12.9865 9.82098 12.6868C9.89195 12.3871 10.0645 12.1212 10.3093 11.9343L10.9333 11.4662C11.2646 11.2178 11.5334 10.8957 11.7185 10.5254C11.9037 10.1551 12.0001 9.74675 12.0001 9.33273V5.33241C12.0001 4.62511 11.7191 3.94678 11.219 3.44664C10.7188 2.9465 10.0405 2.66553 9.33322 2.66553H5.3329C4.6256 2.66553 3.94726 2.9465 3.44713 3.44664C2.94699 3.94678 2.66602 4.62511 2.66602 5.33241C2.66602 11.6981 5.19478 17.8031 9.69602 22.3043C14.1972 26.8056 20.3022 29.3343 26.6679 29.3343C27.3752 29.3343 28.0536 29.0534 28.5537 28.5532C29.0538 28.0531 29.3348 27.3747 29.3348 26.6674V22.6671C29.3348 21.9598 29.0538 21.2815 28.5537 20.7814C28.0536 20.2812 27.3752 20.0002 26.6679 20.0002H22.6676C22.2536 20.0002 21.8453 20.0966 21.475 20.2818C21.1046 20.467 20.7825 20.7358 20.5341 21.067L20.0607 21.687C19.8772 21.9282 19.6169 22.0996 19.3229 22.173Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </SvgIcon>
);

export default PhoneAtencion;
